// eslint-disable-next-line jira/restricted/react-component-props
import React, { forwardRef, type ComponentProps, type Ref } from 'react';
import { styled } from '@compiled/react';
import Button, { type ButtonProps } from '@atlaskit/button/standard-button';
import WatchIcon from '@atlaskit/icon/core/eye-open';
import { token } from '@atlaskit/tokens';

const BaseButton: React.ForwardRefExoticComponent<
	Omit<
		Omit<ButtonProps & React.RefAttributes<HTMLElement>, 'ref'> & {
			ref?:
				| React.RefObject<HTMLElement>
				| ((
						instance: HTMLElement | null,
				  ) => // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
				  | void
						| React.DO_NOT_USE_OR_YOU_WILL_BE_FIRED_CALLBACK_REF_RETURN_VALUES[keyof React.DO_NOT_USE_OR_YOU_WILL_BE_FIRED_CALLBACK_REF_RETURN_VALUES])
				| null
				| undefined;
		},
		'ref'
	> &
		React.RefAttributes<HTMLElement>
> = forwardRef(({ children, ...props }: ComponentProps<typeof Button>, ref?: Ref<HTMLElement>) => (
	<Container data-testid="issue-create-watchers.ui.watchers-trigger-button.base-button.root">
		<Button {...props} appearance="subtle" spacing="default" ref={ref}>
			{children || (
				<ButtonContent data-testid="issue-create-watchers.ui.watchers-trigger-button.base-button.watch-icon">
					<ButtonIcon>
						<WatchIcon spacing="spacious" label="" />
					</ButtonIcon>
				</ButtonContent>
			)}
		</Button>
	</Container>
));

export default BaseButton;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> button': {
		paddingTop: 0,
		paddingRight: token('space.050'),
		paddingBottom: 0,
		paddingLeft: token('space.050'),
		display: 'flex',
		alignItems: 'center',
	},
	display: 'flex',
	justifyContent: 'flex-end',
	marginRight: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonContent = styled.div({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonIcon = styled.div({
	display: 'flex',
});
